import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  userBalanceContainer: {
    marginTop: theme.spacing(8.5),
  },
  balanceCurrencyCode: {
    color: theme.palette.grey['A200'],
    fontSize: theme.spacing(15.5),
    lineHeight: '47px',
    fontWeight: 400,
  },
  balanceValue: {
    color: theme.palette.grey['A400'],
    fontSize: theme.spacing(15),
    lineHeight: '42px',
    fontWeight: 600,
  },
}));
